import React from 'react'

import { Box, useTokens, Typography } from '@barracuda-internal/bds-core-v2'
import { Avatar } from '@mui/material'

const UserInfo: React.FC<{
  initial: string
  headerFrom: string
  user: string
}> = ({ user, headerFrom, initial }) => {
  const tokens = useTokens()

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        width: 'fixed',
        height: 'auto',
        gap: tokens.aliasesSpaceContainerDefault,
        padding: tokens.aliasesSpaceContainerDefault,
        radius: tokens.aliasesBorderRadiusDefault,
        backgroundColor: tokens.aliasesColorBgStaticContainerNeutral,
        border: `${tokens.aliasesBorderWidthDefault} solid ${tokens.aliasesColorBorderStaticContainerNeutral}`
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          width: 'fill',
          height: 'auto',
          gap: tokens.aliasesSpaceContainerSpacious,
          alignItems: 'center'
        }}
      >
        <Avatar>{initial}</Avatar>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            width: 'fill',
            height: 'auto',
            gap: tokens.aliasesSpaceComponentDense
          }}
        >
          <Typography variant="body1Bold" sx={{ textAlign: 'left' }}>
            Sender: {headerFrom}
          </Typography>
        </Box>
      </Box>
    </Box>
  )
}

export default UserInfo
